import script from "./LiverFunction.vue?vue&type=script&setup=true&lang=js"
export * from "./LiverFunction.vue?vue&type=script&setup=true&lang=js"

import "./LiverFunction.vue?vue&type=style&index=0&id=4f8d6016&lang=css"

const __exports__ = script;

export default __exports__